<script>
import axios from 'axios';

export default {
    name: 'Login',
    el: '.wrap',
    components: {},
    props: {
        loginUrl: {
            type: String,
            default: '/user/login',
        },
        previousPage: {
            type: String,
            default: '/loginDefaultUrl',
        },
    },
    mounted() {
    },
    data() {
        return {
            error: false,
            formData: {
                email: '',
                password: '',
                PreviousPage: this.previousPage,
            },
            errorMessage: '',
            loading: false,
            successMsg: '',
        };
    },
    methods: {
        async handleSubmit() {
            try {
                this.loading = true;
                // 發送 POST 請求
                const response = await axios.post(this.loginUrl, this.formData);

                // 根據回應內容進行處理
                if (!response.data.fails) {
                    // 成功，重定向或執行其他操作
                    window.location.href = response.data.url || '/';
                    this.errorMessage = null;
                    this.successMsg = '登入成功，即將跳轉，請勿離開頁面....';
                } else {
                    global.Message.show(response.data.text);
                    // 失敗，顯示錯誤訊息
                    this.errorMessage = response.data.text || '帳號密碼錯誤，請重新確認。';
                    this.loading = false;
                }
            } catch (error) {
                // 異常情況下的錯誤處理
                this.errorMessage = '登入失敗，請稍後再試。';
                this.loading = false;
            }
        }
    }
};
</script>
<style scoped lang="scss">
.error {
    color: red !important;
    display: none;
}
.success {
    color: green !important;
    display: none;
}
.send_submit {
    .btn.btn-primary {
        span{
            color: white !important;
        }
    }
}
</style>
